import { Injectable } from '@angular/core';
import { AppbarConnectorService } from '@office-start/appbar-connector-service';

@Injectable({
    providedIn: 'root'
})
export class AppBarConnectorServiceInjectable {
    private readonly appbarConnectorService;

    constructor(
    ) {
        this.appbarConnectorService = new AppbarConnectorService();
    }

    public  getAppbarConnectorService(): AppbarConnectorService {
        return this.appbarConnectorService;
    }
}
